import React, { useEffect, useState } from "react";
import axios from "axios";
import * as ReactBootstrap from "react-bootstrap";
import { baseURL } from "../../config";
// import Editbtn from '../Skills/images/circum_edit.svg';
// import deletebtn from '../Skills/images/material-symbols-light_delete-outline.svg';
// import viewbtn from '../Skills/images/iconoir_eye-solid.svg';
// import Editbtn from '../Skills/images/circum_edit.svg';
// import deletebtn from '../Skills/images/material-symbols-light_delete-outline.svg';

const UserTable = () => {
  const [posts, setPosts] = useState({ user: [] });
  const [currentPage, setCurrentPage] = useState(1);
  const [postsPerPage] = useState(25);
  const [editedUser, setEditedUser] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [trainingassigneeToDelete, setTrainingassigneeToDelete] =
    useState(null);
  const [viewTrainningassignee, setTrainningAssigne] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);

  useEffect(() => {
    const fetchPostList = async () => {
      try {
        const { data } = await axios(`${baseURL}/getuser`);
        console.log("Fetched data:", data);
        if (Array.isArray(data.user)) {
          setPosts({ user: data.user });
        } else {
          console.error("Data is not an array:", data);
        }
      } catch (error) {
        console.error("Error fetching posts:", error);
      }
    };
    fetchPostList();
  }, []);

  const handleSaveEditedUser = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/userupdate`,
        editedUser
      );
      console.log("Updated user:", response.data);
      const updatedUser = posts.user.map((user) => {
        // if (user.id === editedUser.id) {
        //     return editedUser;
        // }
      });

      //  setPosts({ user: updatedUser });
      setShowEditModal(false);
      window.location.href = "userTable";
    } catch (error) {
      if (error.response && error.response.status === 404) {
        console.error("user not found. Please try again.");
      } else {
        console.error("Error updating user:", error);
      }
    }
  };

  const handleSearch = async (searchval) => {
    try {
      const { data } = await axios(
        `${baseURL}/getusersearch?q=` + searchval
      );
      console.log("Fetched data:", data);
      if (Array.isArray(data.user)) {
        setPosts({ user: data.user });
      } else {
        console.error("Data is not an array:", data);
      }
    } catch (error) {
      console.error("Error fetching posts:", error);
    }
  };
  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
  };

  const handleCloseViewModal = () => {
    setShowViewModal(false);
  };

  const handleEdit = (user) => {
    setEditedUser(user);
    setShowEditModal(false);
    window.location.href = "/userformspage?uid=" + user.id;
  };

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "long", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.user.slice(indexOfFirstPost, indexOfLastPost);

  return (
    <div>
      <div className="col-lg-12 d-flex mt-2 pb-3">
        <div className="col-lg-6">
          <h4 className="text-start">User List</h4>
        </div>
        <div className="col-lg-6">
          <h6 className="text-end">
            Search by Employee id or Name
            <input
              type="text"
              className=" m-2"
              style={{ width: "67%" }}
              name="search"
              onChange={(e) => {
                handleSearch(e.target.value);
              }}
            ></input>
          </h6>
        </div>
      </div>
      <ReactBootstrap.Table striped bordered hover size="sm">
        <thead className="text-center">
          <tr>
            <th>#</th>
            <th>User Name</th>
            <th>Emp. ID</th>
            <th>E-Mail</th>
            <th>Phone </th>
            <th>Department</th>
            <th>Designation</th>
            <th>MOAC</th>
            <th>Action</th>
            {/* <th>Actions</th> */}
          </tr>
        </thead>
        <tbody>
          {currentPosts.map((user, index) => (
            <tr key={index}>
              <td>{user.id}</td>
              <td>{user.username}</td>
              <td>{user.employeeid}</td>
              <td>{user.email}</td>
              <td>{user.phone}</td>

              <td>{user.departmentname}</td>
              <td>{user.designation}</td>
              <td>{user.isappealcommitteemember}</td>
              <td hidden>{user.password}</td>
              <td className="text-center">
                <ReactBootstrap.Button
                  className="btn btn-warning  text-dark border-0 badge"
                  onClick={() => handleEdit(user)}
                >
                  Edit
                </ReactBootstrap.Button>
                {/* <ReactBootstrap.Button className='bg-transparent border-0' variant="danger" onClick={() => handleDelete(user.id)}><img src={deletebtn} alt="Delete" /></ReactBootstrap.Button> */}
              </td>
            </tr>
          ))}
        </tbody>
      </ReactBootstrap.Table>
      {showEditModal && editedUser && (
        <ReactBootstrap.Modal
          show={showEditModal}
          onHide={handleCloseEditModal}
        >
          <ReactBootstrap.Modal.Header closeButton>
            <ReactBootstrap.Modal.Title>Edit User</ReactBootstrap.Modal.Title>
          </ReactBootstrap.Modal.Header>
          <ReactBootstrap.Modal.Body>
            <div>
              <label>User Name :</label>
              <input
                className="border-0"
                type="text"
                value={editedUser.username}
                onChange={(e) =>
                  setEditedUser({ ...editedUser, username: e.target.value })
                }
              />
            </div>
            <div>
              <label>E-mail :</label>
              <input
                className="border-0"
                type="text"
                value={editedUser.email}
                onChange={(e) =>
                  setEditedUser({ ...editedUser, email: e.target.value })
                }
              />
            </div>
            <div>
              <label>Phone Number</label>
              <input
                className="border-0"
                type="text"
                value={editedUser.phone}
                onChange={(e) =>
                  setEditedUser({ ...editedUser, phone: e.target.value })
                }
              />
            </div>
            <div>
              <label>Password :</label>
              <input
                className="border-0"
                type="text"
                value={editedUser.password}
                onChange={(e) =>
                  setEditedUser({ ...editedUser, password: e.target.value })
                }
              />
            </div>
            <div>
              <label>Department ID :</label>
              <input
                className="border-0"
                type="text"
                value={editedUser.departmentname}
                onChange={(e) =>
                  setEditedUser({
                    ...editedUser,
                    departmentname: e.target.value,
                  })
                }
              />
            </div>
          </ReactBootstrap.Modal.Body>
          <ReactBootstrap.Modal.Footer>
            <ReactBootstrap.Button
              variant="secondary"
              onClick={handleCloseEditModal}
            >
              Close
            </ReactBootstrap.Button>
            <ReactBootstrap.Button
              variant="primary"
              onClick={handleSaveEditedUser}
            >
              Update
            </ReactBootstrap.Button>
          </ReactBootstrap.Modal.Footer>
        </ReactBootstrap.Modal>
      )}

      <ReactBootstrap.Pagination>
        {Array.from(
          { length: Math.ceil(posts.user.length / postsPerPage) },
          (_, index) => (
            <ReactBootstrap.Pagination.Item
              key={index}
              onClick={() => paginate(index + 1)}
            >
              {index + 1}
            </ReactBootstrap.Pagination.Item>
          )
        )}
      </ReactBootstrap.Pagination>
    </div>
  );
};

export default UserTable;
